import React from 'react';
import SvgIcon from './SvgIcon';

const CommunicationMethod = props => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M12 12a3 3 0 100-6 3 3 0 000 6zM16.912 3.338a7.5 7.5 0 010 11.325m-9.825 0a7.5 7.5 0 010-11.325M19.575.675a11.249 11.249 0 010 16.65m-15.15 0a11.25 11.25 0 010-16.65"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.95 11.813L6.75 23.25h10.5l-4.2-11.438M8.85 18h6.45"
                stroke="currentColor"
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};

CommunicationMethod.displayName = 'CommunicationMethodIcon';

export default CommunicationMethod;
